<template>
    <div class="ReferralSummary" v-if="RecordData.Id">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <h4>Community Family Info</h4>
                    <div class="record-section">

                        <p v-if="RecordData.CommunityFamily == null">
                            <i class="fa fa-exclamation red" /> This Inquiry has not been assigned to a Community Family yet.  Unless you are closing out the inquiry, you must first Assign To or Create a Community Family to process this further.  You can do this on the FAMILY LINK Tab in this profile.
                        </p>
                        <div v-if="RecordData.CommunityFamily != null">
                            <p><span class="bold">Family Name: </span><span class="link-like" @click="OpenCommunityFamilyProfile()">{{ RecordData.CommunityFamily.Name }}</span></p>
                            <p><span class="bold">Address: </span><span>{{ RecordData.CommunityFamily.PhysicalAddress.AddressSingleLine }}</span> <GoogleMapsLink v-bind:address="RecordData.CommunityFamily.PhysicalAddress" /></p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <h3>Inquiry Info:</h3>
                    <div class="row">
                        <div class="col">
                            <div class="record-section">
                                <p><span class="bold">Inquiry Date: </span>{{ formatDate(RecordData.InquiryDateTime,'MM/DD/YY') }}</p>
                                <p><span class="bold">Inquiry Type: </span>{{ RecordData.InquiryType }}</p>
                                <p><span class="bold">Parent Name(s): </span>{{ RecordData.InqParentNames }}</p>
                                <p><span class="bold">DOB: </span>{{ formatDate(RecordData.InqDOB) }}</p>

                                <p><span class="bold">Language: </span>{{ RecordData.InqPrimaryLanguageSpoken }}</p>
                                <p><span class="bold">Number of Children Needing Assistance: </span>{{ RecordData.InqNumberOfChildrenWhoNeedAssistance }}</p>

                                <p><span class="bold">Urgency: </span>{{ RecordData.InqUrgencyOfAssistanceNeeded }}</p>
                                <p><span class="bold">Referral Source: </span>{{ RecordData.InqReferralSource }}</p>
                                <p><span class="bold">Comments: </span>{{ RecordData.InqReasonForAssistance }}</p>
                            </div>
                            
                        </div>
                        <div class="col">
                            <div class="record-section">
                                <p><span class="bold">Email: </span>{{ RecordData.InqEmail }}</p>
                                <p><span class="bold">Phone: </span>{{ RecordData.InqPhoneNumber }}</p>
                                <p><span class="bold">Address Line 1: </span>{{ RecordData.InqAddressLine1 }}</p>
                                <p><span class="bold">Address Line 2: </span>{{ RecordData.InqAddressLine2 }}</p>
                                <p><span class="bold">City: </span>{{ RecordData.InqCity }}</p>
                                <p><span class="bold">State: </span>{{ RecordData.InqStateAbbreviation }}</p>
                                <p><span class="bold">Zip: </span>{{ RecordData.InqZipCode }}</p>
                                <p><span class="bold">Current Homelessness: </span>{{ RecordData.InqCurrentlyExperiencingHomelessness }}</p>
                            </div>
                            
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //Import Components
    import GoogleMapsLink from "../../../../Core/LinkShortcuts/GoogleMapsLink.vue";

    //Import Services
    import { EventBus } from '../../../../../services/event-bus.js';

    export default {
        name: "ReferralSummary",
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                
            }
        },
        methods: {
            OpenCommunityFamilyProfile() {
                this.$store.commit("CommunityFamilies.Profiles.Append", { Id: this.RecordData.CommunityFamilyID, Name: this.RecordData.CommunityFamily.Name });
                EventBus.$emit('globalpanechange', this.RecordData.CommunityFamilyID);
            },
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
        },
        components: {
            GoogleMapsLink
        },
        mounted() {
        },
        computed: {
            
        }
    }
</script>

<style scoped>
</style>